export const EMAIL_SIGN_UP_URL = process.env.REACT_APP_EMAIL_SIGNUP_URL || ''